interface SelectedLabelsCounterProps {
  selectedCount: number;
  totalCount: number;
  label: string;
}

export function SelectedLabelsCounter({
  selectedCount,
  totalCount,
  label,
}: SelectedLabelsCounterProps) {
  const selectedLabelsText = selectedCount
    ? `${selectedCount} / ${totalCount}`
    : `${totalCount} (All)`;

  return (
    <p data-testid="selected-labels-counter">
      {label}: <span>{selectedLabelsText}</span>
    </p>
  );
}

SelectedLabelsCounter.displayName = 'SelectedLabelsCounter';
